// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminCreateAnswerFirstRecipientData, AdminCreateAnswerFirstRecipientErrors, AdminCreateAnswerFirstRecipientResponses, AdminDeleteAnswerFirstRecipientData, AdminDeleteAnswerFirstRecipientErrors, AdminDeleteAnswerFirstRecipientResponses, AdminGetCoverageMapData, AdminGetCoverageMapErrors, AdminGetCoverageMapResponses, AdminGetCoverageProspectsData, AdminGetCoverageProspectsErrors, AdminGetCoverageProspectsResponses, AdminGetCoverageVolumeData, AdminGetCoverageVolumeErrors, AdminGetCoverageVolumeResponses, AdminGetDispatchBoardData, AdminGetDispatchBoardErrors, AdminGetDispatchBoardResponses, AdminGetDispatchNurseRouteData, AdminGetDispatchNurseRouteErrors, AdminGetDispatchNurseRouteResponses, AdminListAnswerFirstRecipientsData, AdminListAnswerFirstRecipientsErrors, AdminListAnswerFirstRecipientsResponses, AdminListCompaniesData, AdminListCompaniesErrors, AdminListCompaniesResponses, AdminListFacilitiesData, AdminListFacilitiesErrors, AdminListFacilitiesResponses, AdminListUsersData, AdminListUsersErrors, AdminListUsersResponses, AdminSearchUserOptionsData, AdminSearchUserOptionsErrors, AdminSearchUserOptionsResponses, CreateFeatureFlagData, CreateFeatureFlagErrors, CreateFeatureFlagResponses, CreateLinkData, CreateLinkErrors, CreateLinkFolderData, CreateLinkFolderErrors, CreateLinkFolderResponses, CreateLinkResponses, CreateMetabaseGuestTokenData, CreateMetabaseGuestTokenErrors, CreateMetabaseGuestTokenResponses, CreateReportData, CreateReportErrors, CreateReportResponses, CreateSubscriptionData, CreateSubscriptionErrors, CreateSubscriptionResponses, DeleteFeatureFlagData, DeleteFeatureFlagErrors, DeleteFeatureFlagResponses, DeleteLinkData, DeleteLinkErrors, DeleteLinkFolderData, DeleteLinkFolderErrors, DeleteLinkFolderResponses, DeleteLinkResponses, DeleteReportData, DeleteReportErrors, DeleteReportResponses, DeleteSubscriptionData, DeleteSubscriptionErrors, DeleteSubscriptionResponses, GenerateOAuthCallbackData, GenerateOAuthCallbackResponses, GetCurrentUserData, GetCurrentUserErrors, GetCurrentUserResponses, GetMaintenanceStatusData, GetMaintenanceStatusErrors, GetMaintenanceStatusResponses, GetMyFeatureFlagsData, GetMyFeatureFlagsErrors, GetMyFeatureFlagsResponses, GetReportData, GetReportErrors, GetReportResponses, GetSubscriptionHistoryData, GetSubscriptionHistoryErrors, GetSubscriptionHistoryResponses, GoogleOAuthCallbackData, GoogleOAuthCallbackErrors, GoogleOAuthCallbackResponses, HealthyApiV1HealthyGetData, HealthyApiV1HealthyGetResponses, HealthyApiV1HealthyHeadData, HealthyApiV1HealthyHeadResponses, ListCompaniesData, ListCompaniesErrors, ListCompaniesResponses, ListFacilitiesData, ListFacilitiesErrors, ListFacilitiesResponses, ListFeatureFlagsData, ListFeatureFlagsErrors, ListFeatureFlagsResponses, ListHubItemsData, ListHubItemsErrors, ListHubItemsResponses, ListReportsData, ListReportsErrors, ListReportsResponses, ListSubscriptionAutoRecipientsData, ListSubscriptionAutoRecipientsErrors, ListSubscriptionAutoRecipientsResponses, ListSubscriptionContactsData, ListSubscriptionContactsErrors, ListSubscriptionContactsResponses, ListSubscriptionsData, ListSubscriptionsErrors, ListSubscriptionsResponses, LogoutData, LogoutResponses, ReorderHubItemsData, ReorderHubItemsErrors, ReorderHubItemsResponses, ReorderReportsData, ReorderReportsErrors, ReorderReportsResponses, SendSubscriptionData, SendSubscriptionErrors, SendSubscriptionResponses, SetMaintenanceData, SetMaintenanceErrors, SetMaintenanceResponses, SuggestDescriptionData, SuggestDescriptionErrors, SuggestDescriptionResponses, SuggestIconsData, SuggestIconsErrors, SuggestIconsResponses, UpdateFeatureFlagData, UpdateFeatureFlagErrors, UpdateFeatureFlagResponses, UpdateLinkData, UpdateLinkErrors, UpdateLinkFolderData, UpdateLinkFolderErrors, UpdateLinkFolderResponses, UpdateLinkResponses, UpdateReportData, UpdateReportErrors, UpdateReportResponses, UpdateSubscriptionData, UpdateSubscriptionErrors, UpdateSubscriptionResponses, VellumApiApplyPermifyTenantData, VellumApiApplyPermifyTenantErrors, VellumApiApplyPermifyTenantResponses, VellumApiCheckPermifyPermissionData, VellumApiCheckPermifyPermissionErrors, VellumApiCheckPermifyPermissionResponses, VellumApiCreatePermifySchemaData, VellumApiCreatePermifySchemaErrors, VellumApiCreatePermifySchemaResponses, VellumApiCreatePermifyTenantData, VellumApiCreatePermifyTenantErrors, VellumApiCreatePermifyTenantResponses, VellumApiGetPermifySchemaData, VellumApiGetPermifySchemaErrors, VellumApiGetPermifySchemaHeadData, VellumApiGetPermifySchemaHeadErrors, VellumApiGetPermifySchemaHeadResponses, VellumApiGetPermifySchemaHeadSummaryData, VellumApiGetPermifySchemaHeadSummaryErrors, VellumApiGetPermifySchemaHeadSummaryResponses, VellumApiGetPermifySchemaResponses, VellumApiGetPermifySchemaSummaryData, VellumApiGetPermifySchemaSummaryErrors, VellumApiGetPermifySchemaSummaryResponses, VellumApiGetPermifyTenantData, VellumApiGetPermifyTenantErrors, VellumApiGetPermifyTenantResponses, VellumApiGrantPermifyPermissionData, VellumApiGrantPermifyPermissionErrors, VellumApiGrantPermifyPermissionResponses, VellumApiListExpectedPermifyTenantsData, VellumApiListExpectedPermifyTenantsErrors, VellumApiListExpectedPermifyTenantsResponses, VellumApiListPermifyCustomerPlatformUsersData, VellumApiListPermifyCustomerPlatformUsersErrors, VellumApiListPermifyCustomerPlatformUsersResponses, VellumApiListPermifyLunaUsersData, VellumApiListPermifyLunaUsersErrors, VellumApiListPermifyLunaUsersResponses, VellumApiListPermifySchemasData, VellumApiListPermifySchemasErrors, VellumApiListPermifySchemasResponses, VellumApiListPermifyTenantsData, VellumApiListPermifyTenantsErrors, VellumApiListPermifyTenantsResponses, VellumApiReadPermifyRelationshipsData, VellumApiReadPermifyRelationshipsErrors, VellumApiReadPermifyRelationshipsResponses, VellumApiSyncPermifyCustomerPlatformUserData, VellumApiSyncPermifyCustomerPlatformUserErrors, VellumApiSyncPermifyCustomerPlatformUserResponses, VellumApiSyncPermifyLunaUserData, VellumApiSyncPermifyLunaUserErrors, VellumApiSyncPermifyLunaUserResponses, WhoamiData, WhoamiErrors, WhoamiResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Healthy
 */
export const healthyApiV1HealthyGet = <ThrowOnError extends boolean = false>(options?: Options<HealthyApiV1HealthyGetData, ThrowOnError>): RequestResult<HealthyApiV1HealthyGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthyApiV1HealthyGetResponses, unknown, ThrowOnError>({ url: '/api/v1/healthy', ...options });

/**
 * Healthy
 */
export const healthyApiV1HealthyHead = <ThrowOnError extends boolean = false>(options?: Options<HealthyApiV1HealthyHeadData, ThrowOnError>): RequestResult<HealthyApiV1HealthyHeadResponses, unknown, ThrowOnError> => (options?.client ?? client).head<HealthyApiV1HealthyHeadResponses, unknown, ThrowOnError>({ url: '/api/v1/healthy', ...options });

/**
 * Admin List Answer First Recipients
 *
 * List everyone currently notified of AnswerFirst failures. Admin only.
 */
export const adminListAnswerFirstRecipients = <ThrowOnError extends boolean = false>(options?: Options<AdminListAnswerFirstRecipientsData, ThrowOnError>): RequestResult<AdminListAnswerFirstRecipientsResponses, AdminListAnswerFirstRecipientsErrors, ThrowOnError> => (options?.client ?? client).get<AdminListAnswerFirstRecipientsResponses, AdminListAnswerFirstRecipientsErrors, ThrowOnError>({ url: '/api/v1/admin/answer-first-recipients', ...options });

/**
 * Admin Create Answer First Recipient
 *
 * Add a user to the notification list. Admin only.
 */
export const adminCreateAnswerFirstRecipient = <ThrowOnError extends boolean = false>(options: Options<AdminCreateAnswerFirstRecipientData, ThrowOnError>): RequestResult<AdminCreateAnswerFirstRecipientResponses, AdminCreateAnswerFirstRecipientErrors, ThrowOnError> => (options.client ?? client).post<AdminCreateAnswerFirstRecipientResponses, AdminCreateAnswerFirstRecipientErrors, ThrowOnError>({
    url: '/api/v1/admin/answer-first-recipients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Answer First Recipient
 *
 * Remove a user from the notification list. Admin only.
 */
export const adminDeleteAnswerFirstRecipient = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteAnswerFirstRecipientData, ThrowOnError>): RequestResult<AdminDeleteAnswerFirstRecipientResponses, AdminDeleteAnswerFirstRecipientErrors, ThrowOnError> => (options.client ?? client).delete<AdminDeleteAnswerFirstRecipientResponses, AdminDeleteAnswerFirstRecipientErrors, ThrowOnError>({ url: '/api/v1/admin/answer-first-recipients/{recipient_id}', ...options });

/**
 * Admin List Companies
 *
 * List live companies, alphabetically. Admin only.
 */
export const adminListCompanies = <ThrowOnError extends boolean = false>(options?: Options<AdminListCompaniesData, ThrowOnError>): RequestResult<AdminListCompaniesResponses, AdminListCompaniesErrors, ThrowOnError> => (options?.client ?? client).get<AdminListCompaniesResponses, AdminListCompaniesErrors, ThrowOnError>({ url: '/api/v1/admin/companies', ...options });

/**
 * Admin Get Coverage Map
 *
 * Live regions, facilities, and nurses for the coverage map. Admin only.
 *
 * Nurses are the field roster plus anyone, whatever their role, who did a
 * visit since ``since`` (triage nurses and region admins take visits too).
 * Facilities and nurses without coordinates can't be plotted; facilities are
 * counted, and nurses are listed so their addresses can be fixed. Each
 * facility carries its newest job's creation time so the page can hide idle
 * sites.
 */
export const adminGetCoverageMap = <ThrowOnError extends boolean = false>(options?: Options<AdminGetCoverageMapData, ThrowOnError>): RequestResult<AdminGetCoverageMapResponses, AdminGetCoverageMapErrors, ThrowOnError> => (options?.client ?? client).get<AdminGetCoverageMapResponses, AdminGetCoverageMapErrors, ThrowOnError>({ url: '/api/v1/admin/coverage/map', ...options });

/**
 * Admin Get Coverage Volume
 *
 * Weekly visited jobs and encounters per facility, by type. Admin only.
 *
 * Jobs count in the week they were visited (see _visited_job_rows), so the
 * numbers reflect work done rather than jobs booked. Encounters (patients
 * seen) count by completion. Every encounter type is returned; the page
 * decides which ones represent a billed patient. Legacy jobsv2 is
 * deliberately ignored.
 */
export const adminGetCoverageVolume = <ThrowOnError extends boolean = false>(options?: Options<AdminGetCoverageVolumeData, ThrowOnError>): RequestResult<AdminGetCoverageVolumeResponses, AdminGetCoverageVolumeErrors, ThrowOnError> => (options?.client ?? client).get<AdminGetCoverageVolumeResponses, AdminGetCoverageVolumeErrors, ThrowOnError>({ url: '/api/v1/admin/coverage/volume', ...options });

/**
 * Admin Get Coverage Prospects
 *
 * Nursing homes from the latest monthly CMS release, for the map. Admin only.
 *
 * Limited to states where we already have a facility, so the layer shows
 * prospects in markets we serve. Homes CMS couldn't geocode are left out. A home is linked to our facility
 * when that facility carries its CMS certification number, so the page can
 * tell existing customers from prospects.
 */
export const adminGetCoverageProspects = <ThrowOnError extends boolean = false>(options?: Options<AdminGetCoverageProspectsData, ThrowOnError>): RequestResult<AdminGetCoverageProspectsResponses, AdminGetCoverageProspectsErrors, ThrowOnError> => (options?.client ?? client).get<AdminGetCoverageProspectsResponses, AdminGetCoverageProspectsErrors, ThrowOnError>({ url: '/api/v1/admin/coverage/prospects', ...options });

/**
 * Admin Get Dispatch Board
 *
 * Today's infusion and vascular access jobs and each nurse's route. Admin only.
 *
 * "Today" is each facility's own date. Nurse positions are inferred from
 * check-ins: home until their first check-in, then the facility they're at
 * or last left. Drive times come from address_routes, which the
 * calc_dispatch_routes cron fills in for every leg on today's queues.
 *
 * Regions narrow what's listed, not how queues are built: a nurse with a
 * job in the selected regions comes with their whole day, so a route
 * through two regions doesn't skip the stops in the other one.
 */
export const adminGetDispatchBoard = <ThrowOnError extends boolean = false>(options?: Options<AdminGetDispatchBoardData, ThrowOnError>): RequestResult<AdminGetDispatchBoardResponses, AdminGetDispatchBoardErrors, ThrowOnError> => (options?.client ?? client).get<AdminGetDispatchBoardResponses, AdminGetDispatchBoardErrors, ThrowOnError>({ url: '/api/v1/admin/dispatch/board', ...options });

/**
 * Admin Get Dispatch Nurse Route
 *
 * The roads one nurse drives today, every cached point. Admin only.
 *
 * Fetched when a nurse is highlighted on the board, so the board itself
 * stays light enough to poll. Legs whose road the calc_dispatch_routes cron
 * hasn't cached yet are left out; the board draws those as straight lines.
 */
export const adminGetDispatchNurseRoute = <ThrowOnError extends boolean = false>(options: Options<AdminGetDispatchNurseRouteData, ThrowOnError>): RequestResult<AdminGetDispatchNurseRouteResponses, AdminGetDispatchNurseRouteErrors, ThrowOnError> => (options.client ?? client).get<AdminGetDispatchNurseRouteResponses, AdminGetDispatchNurseRouteErrors, ThrowOnError>({ url: '/api/v1/admin/dispatch/nurses/{nurse_id}/route', ...options });

/**
 * Admin List Facilities
 *
 * List live facilities, alphabetically. Admin only.
 */
export const adminListFacilities = <ThrowOnError extends boolean = false>(options?: Options<AdminListFacilitiesData, ThrowOnError>): RequestResult<AdminListFacilitiesResponses, AdminListFacilitiesErrors, ThrowOnError> => (options?.client ?? client).get<AdminListFacilitiesResponses, AdminListFacilitiesErrors, ThrowOnError>({ url: '/api/v1/admin/facilities', ...options });

/**
 * Admin Search User Options
 *
 * Look up Luna users for a picker. Admin only.
 *
 * Pass ``ids`` to resolve specific users (so a control can render selections
 * it only knows by id). Otherwise pass ``q`` to search by name or email; an
 * empty query returns the first users by name. Facility accounts are
 * excluded — they are tracking records, never a person you'd pick.
 */
export const adminSearchUserOptions = <ThrowOnError extends boolean = false>(options?: Options<AdminSearchUserOptionsData, ThrowOnError>): RequestResult<AdminSearchUserOptionsResponses, AdminSearchUserOptionsErrors, ThrowOnError> => (options?.client ?? client).get<AdminSearchUserOptionsResponses, AdminSearchUserOptionsErrors, ThrowOnError>({ url: '/api/v1/admin/user-options', ...options });

/**
 * Admin List Users
 *
 * List every live user who can sign in, by name. Admin only.
 *
 * Facility-role rows are tracking records with no login, so they are excluded —
 * the same rule the Luna internal users endpoint applies.
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminListUsersData, ThrowOnError>): RequestResult<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError> => (options?.client ?? client).get<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError>({ url: '/api/v1/admin/users', ...options });

/**
 * Suggest Description
 */
export const suggestDescription = <ThrowOnError extends boolean = false>(options: Options<SuggestDescriptionData, ThrowOnError>): RequestResult<SuggestDescriptionResponses, SuggestDescriptionErrors, ThrowOnError> => (options.client ?? client).post<SuggestDescriptionResponses, SuggestDescriptionErrors, ThrowOnError>({
    url: '/api/v1/ai/suggest-description',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suggest Icons
 *
 * Icon names from ``candidates`` that suit ``subject``, best first.
 *
 * The model's answer is filtered back down to ``candidates``, so a
 * hallucinated or stale name never reaches the UI. An empty list is a valid
 * response: suggestions are a convenience and must not block the form.
 */
export const suggestIcons = <ThrowOnError extends boolean = false>(options: Options<SuggestIconsData, ThrowOnError>): RequestResult<SuggestIconsResponses, SuggestIconsErrors, ThrowOnError> => (options.client ?? client).post<SuggestIconsResponses, SuggestIconsErrors, ThrowOnError>({
    url: '/api/v1/ai/suggest-icons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Whoami
 *
 * Plaintext email when session is valid; 403 when unauthenticated.
 */
export const whoami = <ThrowOnError extends boolean = false>(options?: Options<WhoamiData, ThrowOnError>): RequestResult<WhoamiResponses, WhoamiErrors, ThrowOnError> => (options?.client ?? client).get<WhoamiResponses, WhoamiErrors, ThrowOnError>({ url: '/api/v1/', ...options });

/**
 * Generate Oauth Callback
 *
 * Start Google OAuth: redirect to Google authorization page.
 */
export const generateOAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<GenerateOAuthCallbackData, ThrowOnError>): RequestResult<GenerateOAuthCallbackResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GenerateOAuthCallbackResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/generate-callback', ...options });

/**
 * Google Oauth Callback
 *
 * OAuth callback: exchange code, upsert Luna user, set JWT cookie, redirect to app.
 */
export const googleOAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<GoogleOAuthCallbackData, ThrowOnError>): RequestResult<GoogleOAuthCallbackResponses, GoogleOAuthCallbackErrors, ThrowOnError> => (options?.client ?? client).get<GoogleOAuthCallbackResponses, GoogleOAuthCallbackErrors, ThrowOnError>({ url: '/api/v1/auth/callback/google', ...options });

/**
 * Logout
 *
 * Clear the session cookie (204).
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/logout', ...options });

/**
 * Get Current User
 *
 * Return the authenticated Luna user (401 if missing/invalid session).
 *
 * Accepts legacy Luna ``luna_access_token`` or Vellum ``vellum_auth_token`` cookie.
 * Every micro app calls this on mount, so a legacy-only session is transparently
 * upgraded here: we mint a Vellum JWT and set the cookie, which unblocks the
 * Vellum-only endpoints (admin, permify, ai, mutations). The minted token
 * expires with the legacy Cognito token it was derived from.
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserData, ThrowOnError>): RequestResult<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError>({ url: '/api/v1/auth/me', ...options });

/**
 * List Feature Flags
 *
 * All flags with full targeting rules, ordered by key. Admin-only.
 */
export const listFeatureFlags = <ThrowOnError extends boolean = false>(options?: Options<ListFeatureFlagsData, ThrowOnError>): RequestResult<ListFeatureFlagsResponses, ListFeatureFlagsErrors, ThrowOnError> => (options?.client ?? client).get<ListFeatureFlagsResponses, ListFeatureFlagsErrors, ThrowOnError>({ url: '/api/v1/flags', ...options });

/**
 * Create Feature Flag
 */
export const createFeatureFlag = <ThrowOnError extends boolean = false>(options: Options<CreateFeatureFlagData, ThrowOnError>): RequestResult<CreateFeatureFlagResponses, CreateFeatureFlagErrors, ThrowOnError> => (options.client ?? client).post<CreateFeatureFlagResponses, CreateFeatureFlagErrors, ThrowOnError>({
    url: '/api/v1/flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Feature Flag
 */
export const deleteFeatureFlag = <ThrowOnError extends boolean = false>(options: Options<DeleteFeatureFlagData, ThrowOnError>): RequestResult<DeleteFeatureFlagResponses, DeleteFeatureFlagErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFeatureFlagResponses, DeleteFeatureFlagErrors, ThrowOnError>({ url: '/api/v1/flags/{flag_id}', ...options });

/**
 * Update Feature Flag
 */
export const updateFeatureFlag = <ThrowOnError extends boolean = false>(options: Options<UpdateFeatureFlagData, ThrowOnError>): RequestResult<UpdateFeatureFlagResponses, UpdateFeatureFlagErrors, ThrowOnError> => (options.client ?? client).patch<UpdateFeatureFlagResponses, UpdateFeatureFlagErrors, ThrowOnError>({
    url: '/api/v1/flags/{flag_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Feature Flags
 *
 * The caller's evaluated flags as a flat ``{key: bool}`` map.
 *
 * Targeting rules and other users' ids are never exposed here — only the
 * boolean result of evaluating each flag for the authenticated caller.
 */
export const getMyFeatureFlags = <ThrowOnError extends boolean = false>(options?: Options<GetMyFeatureFlagsData, ThrowOnError>): RequestResult<GetMyFeatureFlagsResponses, GetMyFeatureFlagsErrors, ThrowOnError> => (options?.client ?? client).get<GetMyFeatureFlagsResponses, GetMyFeatureFlagsErrors, ThrowOnError>({ url: '/api/v1/flags/me', ...options });

/**
 * Get Hub Items
 *
 * Everything the hub home page renders: links and folders as one ordered
 * list per section, filtered to the caller's role.
 */
export const listHubItems = <ThrowOnError extends boolean = false>(options?: Options<ListHubItemsData, ThrowOnError>): RequestResult<ListHubItemsResponses, ListHubItemsErrors, ThrowOnError> => (options?.client ?? client).get<ListHubItemsResponses, ListHubItemsErrors, ThrowOnError>({ url: '/api/v1/hub/items', ...options });

/**
 * Reorder Hub Items
 *
 * Sets section, folder and sort_order for every listed item in one
 * request; ``sort_order`` is each item's index within its container.
 *
 * Every section and folder in the request must be listed in full, except for
 * items the same request moves elsewhere; sections and folders left out of
 * the request are untouched.
 */
export const reorderHubItems = <ThrowOnError extends boolean = false>(options: Options<ReorderHubItemsData, ThrowOnError>): RequestResult<ReorderHubItemsResponses, ReorderHubItemsErrors, ThrowOnError> => (options.client ?? client).put<ReorderHubItemsResponses, ReorderHubItemsErrors, ThrowOnError>({
    url: '/api/v1/hub/items/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Link Folder
 */
export const createLinkFolder = <ThrowOnError extends boolean = false>(options: Options<CreateLinkFolderData, ThrowOnError>): RequestResult<CreateLinkFolderResponses, CreateLinkFolderErrors, ThrowOnError> => (options.client ?? client).post<CreateLinkFolderResponses, CreateLinkFolderErrors, ThrowOnError>({
    url: '/api/v1/link-folders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Link Folder
 *
 * Soft-deletes the folder. Its links are never deleted with it: they're
 * unfiled and appended, in folder order, after the section's top-level items.
 */
export const deleteLinkFolder = <ThrowOnError extends boolean = false>(options: Options<DeleteLinkFolderData, ThrowOnError>): RequestResult<DeleteLinkFolderResponses, DeleteLinkFolderErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLinkFolderResponses, DeleteLinkFolderErrors, ThrowOnError>({ url: '/api/v1/link-folders/{folder_id}', ...options });

/**
 * Update Link Folder
 */
export const updateLinkFolder = <ThrowOnError extends boolean = false>(options: Options<UpdateLinkFolderData, ThrowOnError>): RequestResult<UpdateLinkFolderResponses, UpdateLinkFolderErrors, ThrowOnError> => (options.client ?? client).patch<UpdateLinkFolderResponses, UpdateLinkFolderErrors, ThrowOnError>({
    url: '/api/v1/link-folders/{folder_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Link
 */
export const createLink = <ThrowOnError extends boolean = false>(options: Options<CreateLinkData, ThrowOnError>): RequestResult<CreateLinkResponses, CreateLinkErrors, ThrowOnError> => (options.client ?? client).post<CreateLinkResponses, CreateLinkErrors, ThrowOnError>({
    url: '/api/v1/links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Link
 */
export const deleteLink = <ThrowOnError extends boolean = false>(options: Options<DeleteLinkData, ThrowOnError>): RequestResult<DeleteLinkResponses, DeleteLinkErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLinkResponses, DeleteLinkErrors, ThrowOnError>({ url: '/api/v1/links/{link_id}', ...options });

/**
 * Update Link
 */
export const updateLink = <ThrowOnError extends boolean = false>(options: Options<UpdateLinkData, ThrowOnError>): RequestResult<UpdateLinkResponses, UpdateLinkErrors, ThrowOnError> => (options.client ?? client).patch<UpdateLinkResponses, UpdateLinkErrors, ThrowOnError>({
    url: '/api/v1/links/{link_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Maintenance Status
 *
 * Whether each app's maintenance page is on. Admin-only.
 */
export const getMaintenanceStatus = <ThrowOnError extends boolean = false>(options?: Options<GetMaintenanceStatusData, ThrowOnError>): RequestResult<GetMaintenanceStatusResponses, GetMaintenanceStatusErrors, ThrowOnError> => (options?.client ?? client).get<GetMaintenanceStatusResponses, GetMaintenanceStatusErrors, ThrowOnError>({ url: '/api/v1/maintenance', ...options });

/**
 * Set Maintenance
 *
 * Turn an app's maintenance page on or off. Admin-only.
 */
export const setMaintenance = <ThrowOnError extends boolean = false>(options: Options<SetMaintenanceData, ThrowOnError>): RequestResult<SetMaintenanceResponses, SetMaintenanceErrors, ThrowOnError> => (options.client ?? client).post<SetMaintenanceResponses, SetMaintenanceErrors, ThrowOnError>({
    url: '/api/v1/maintenance/{app}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Expected Tenants
 *
 * List the two expected Permify tenants and their provisioning status.
 */
export const vellumApiListExpectedPermifyTenants = <ThrowOnError extends boolean = false>(options?: Options<VellumApiListExpectedPermifyTenantsData, ThrowOnError>): RequestResult<VellumApiListExpectedPermifyTenantsResponses, VellumApiListExpectedPermifyTenantsErrors, ThrowOnError> => (options?.client ?? client).get<VellumApiListExpectedPermifyTenantsResponses, VellumApiListExpectedPermifyTenantsErrors, ThrowOnError>({ url: '/api/v1/permify/expected-tenants', ...options });

/**
 * Apply Tenant
 *
 * Create a missing tenant and sync its schema from the bundled .perm file.
 */
export const vellumApiApplyPermifyTenant = <ThrowOnError extends boolean = false>(options: Options<VellumApiApplyPermifyTenantData, ThrowOnError>): RequestResult<VellumApiApplyPermifyTenantResponses, VellumApiApplyPermifyTenantErrors, ThrowOnError> => (options.client ?? client).post<VellumApiApplyPermifyTenantResponses, VellumApiApplyPermifyTenantErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/apply', ...options });

/**
 * List Tenants
 *
 * List all Permify tenants.
 */
export const vellumApiListPermifyTenants = <ThrowOnError extends boolean = false>(options?: Options<VellumApiListPermifyTenantsData, ThrowOnError>): RequestResult<VellumApiListPermifyTenantsResponses, VellumApiListPermifyTenantsErrors, ThrowOnError> => (options?.client ?? client).get<VellumApiListPermifyTenantsResponses, VellumApiListPermifyTenantsErrors, ThrowOnError>({ url: '/api/v1/permify/tenants', ...options });

/**
 * Create Tenant
 *
 * Create a Permify tenant.
 */
export const vellumApiCreatePermifyTenant = <ThrowOnError extends boolean = false>(options: Options<VellumApiCreatePermifyTenantData, ThrowOnError>): RequestResult<VellumApiCreatePermifyTenantResponses, VellumApiCreatePermifyTenantErrors, ThrowOnError> => (options.client ?? client).post<VellumApiCreatePermifyTenantResponses, VellumApiCreatePermifyTenantErrors, ThrowOnError>({
    url: '/api/v1/permify/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Tenant
 *
 * Get a Permify tenant by id.
 */
export const vellumApiGetPermifyTenant = <ThrowOnError extends boolean = false>(options: Options<VellumApiGetPermifyTenantData, ThrowOnError>): RequestResult<VellumApiGetPermifyTenantResponses, VellumApiGetPermifyTenantErrors, ThrowOnError> => (options.client ?? client).get<VellumApiGetPermifyTenantResponses, VellumApiGetPermifyTenantErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}', ...options });

/**
 * List Schemas
 *
 * List schema versions for a Permify tenant.
 */
export const vellumApiListPermifySchemas = <ThrowOnError extends boolean = false>(options: Options<VellumApiListPermifySchemasData, ThrowOnError>): RequestResult<VellumApiListPermifySchemasResponses, VellumApiListPermifySchemasErrors, ThrowOnError> => (options.client ?? client).get<VellumApiListPermifySchemasResponses, VellumApiListPermifySchemasErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/schemas', ...options });

/**
 * Create Schema
 *
 * Write a new schema version for a tenant.
 */
export const vellumApiCreatePermifySchema = <ThrowOnError extends boolean = false>(options: Options<VellumApiCreatePermifySchemaData, ThrowOnError>): RequestResult<VellumApiCreatePermifySchemaResponses, VellumApiCreatePermifySchemaErrors, ThrowOnError> => (options.client ?? client).post<VellumApiCreatePermifySchemaResponses, VellumApiCreatePermifySchemaErrors, ThrowOnError>({
    url: '/api/v1/permify/tenants/{tenant_id}/schemas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Schema Head
 *
 * Return the latest (head) schema version for a tenant.
 */
export const vellumApiGetPermifySchemaHead = <ThrowOnError extends boolean = false>(options: Options<VellumApiGetPermifySchemaHeadData, ThrowOnError>): RequestResult<VellumApiGetPermifySchemaHeadResponses, VellumApiGetPermifySchemaHeadErrors, ThrowOnError> => (options.client ?? client).get<VellumApiGetPermifySchemaHeadResponses, VellumApiGetPermifySchemaHeadErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/schemas/head', ...options });

/**
 * Get Schema Head Summary
 *
 * Return a human-readable summary of the latest schema version.
 */
export const vellumApiGetPermifySchemaHeadSummary = <ThrowOnError extends boolean = false>(options: Options<VellumApiGetPermifySchemaHeadSummaryData, ThrowOnError>): RequestResult<VellumApiGetPermifySchemaHeadSummaryResponses, VellumApiGetPermifySchemaHeadSummaryErrors, ThrowOnError> => (options.client ?? client).get<VellumApiGetPermifySchemaHeadSummaryResponses, VellumApiGetPermifySchemaHeadSummaryErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/schemas/head/summary', ...options });

/**
 * Get Schema Summary
 *
 * Return a human-readable summary of a specific schema version.
 */
export const vellumApiGetPermifySchemaSummary = <ThrowOnError extends boolean = false>(options: Options<VellumApiGetPermifySchemaSummaryData, ThrowOnError>): RequestResult<VellumApiGetPermifySchemaSummaryResponses, VellumApiGetPermifySchemaSummaryErrors, ThrowOnError> => (options.client ?? client).get<VellumApiGetPermifySchemaSummaryResponses, VellumApiGetPermifySchemaSummaryErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/schemas/{version}/summary', ...options });

/**
 * Get Schema
 *
 * Read a specific schema version.
 */
export const vellumApiGetPermifySchema = <ThrowOnError extends boolean = false>(options: Options<VellumApiGetPermifySchemaData, ThrowOnError>): RequestResult<VellumApiGetPermifySchemaResponses, VellumApiGetPermifySchemaErrors, ThrowOnError> => (options.client ?? client).get<VellumApiGetPermifySchemaResponses, VellumApiGetPermifySchemaErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/schemas/{version}', ...options });

/**
 * Read Relationships
 *
 * Read stored Permify relationship tuples for a tenant.
 */
export const vellumApiReadPermifyRelationships = <ThrowOnError extends boolean = false>(options: Options<VellumApiReadPermifyRelationshipsData, ThrowOnError>): RequestResult<VellumApiReadPermifyRelationshipsResponses, VellumApiReadPermifyRelationshipsErrors, ThrowOnError> => (options.client ?? client).post<VellumApiReadPermifyRelationshipsResponses, VellumApiReadPermifyRelationshipsErrors, ThrowOnError>({
    url: '/api/v1/permify/tenants/{tenant_id}/relationships/read',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Permission
 *
 * Check whether a subject has a permission on an entity.
 */
export const vellumApiCheckPermifyPermission = <ThrowOnError extends boolean = false>(options: Options<VellumApiCheckPermifyPermissionData, ThrowOnError>): RequestResult<VellumApiCheckPermifyPermissionResponses, VellumApiCheckPermifyPermissionErrors, ThrowOnError> => (options.client ?? client).post<VellumApiCheckPermifyPermissionResponses, VellumApiCheckPermifyPermissionErrors, ThrowOnError>({
    url: '/api/v1/permify/tenants/{tenant_id}/permissions/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Grant Permission
 *
 * Grant a relationship tuple (write permission data).
 */
export const vellumApiGrantPermifyPermission = <ThrowOnError extends boolean = false>(options: Options<VellumApiGrantPermifyPermissionData, ThrowOnError>): RequestResult<VellumApiGrantPermifyPermissionResponses, VellumApiGrantPermifyPermissionErrors, ThrowOnError> => (options.client ?? client).post<VellumApiGrantPermifyPermissionResponses, VellumApiGrantPermifyPermissionErrors, ThrowOnError>({
    url: '/api/v1/permify/tenants/{tenant_id}/permissions/grant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Luna Users
 *
 * List Luna users with platform-level Permify tuples for the given tenant.
 */
export const vellumApiListPermifyLunaUsers = <ThrowOnError extends boolean = false>(options: Options<VellumApiListPermifyLunaUsersData, ThrowOnError>): RequestResult<VellumApiListPermifyLunaUsersResponses, VellumApiListPermifyLunaUsersErrors, ThrowOnError> => (options.client ?? client).get<VellumApiListPermifyLunaUsersResponses, VellumApiListPermifyLunaUsersErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/luna/users', ...options });

/**
 * List Customer Platform Users
 *
 * List Customer Platform users with service-level Permify tuples.
 */
export const vellumApiListPermifyCustomerPlatformUsers = <ThrowOnError extends boolean = false>(options: Options<VellumApiListPermifyCustomerPlatformUsersData, ThrowOnError>): RequestResult<VellumApiListPermifyCustomerPlatformUsersResponses, VellumApiListPermifyCustomerPlatformUsersErrors, ThrowOnError> => (options.client ?? client).get<VellumApiListPermifyCustomerPlatformUsersResponses, VellumApiListPermifyCustomerPlatformUsersErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/customer-platform/users', ...options });

/**
 * Sync Luna User
 *
 * Grant the Luna platform relation that matches the user's DB role.
 */
export const vellumApiSyncPermifyLunaUser = <ThrowOnError extends boolean = false>(options: Options<VellumApiSyncPermifyLunaUserData, ThrowOnError>): RequestResult<VellumApiSyncPermifyLunaUserResponses, VellumApiSyncPermifyLunaUserErrors, ThrowOnError> => (options.client ?? client).post<VellumApiSyncPermifyLunaUserResponses, VellumApiSyncPermifyLunaUserErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/luna/users/{user_id}/sync', ...options });

/**
 * Sync Customer Platform User
 *
 * Grant the Customer Platform service relation that matches the user's DB role.
 */
export const vellumApiSyncPermifyCustomerPlatformUser = <ThrowOnError extends boolean = false>(options: Options<VellumApiSyncPermifyCustomerPlatformUserData, ThrowOnError>): RequestResult<VellumApiSyncPermifyCustomerPlatformUserResponses, VellumApiSyncPermifyCustomerPlatformUserErrors, ThrowOnError> => (options.client ?? client).post<VellumApiSyncPermifyCustomerPlatformUserResponses, VellumApiSyncPermifyCustomerPlatformUserErrors, ThrowOnError>({ url: '/api/v1/permify/tenants/{tenant_id}/customer-platform/users/{user_id}/sync', ...options });

/**
 * List Companies
 *
 * List companies from Luna for the reporting app (open, no auth for now).
 */
export const listCompanies = <ThrowOnError extends boolean = false>(options?: Options<ListCompaniesData, ThrowOnError>): RequestResult<ListCompaniesResponses, ListCompaniesErrors, ThrowOnError> => (options?.client ?? client).get<ListCompaniesResponses, ListCompaniesErrors, ThrowOnError>({ url: '/api/v1/companies', ...options });

/**
 * List Facilities
 *
 * List facilities from Luna for the reporting app (open, no auth for now).
 */
export const listFacilities = <ThrowOnError extends boolean = false>(options?: Options<ListFacilitiesData, ThrowOnError>): RequestResult<ListFacilitiesResponses, ListFacilitiesErrors, ThrowOnError> => (options?.client ?? client).get<ListFacilitiesResponses, ListFacilitiesErrors, ThrowOnError>({ url: '/api/v1/facilities', ...options });

/**
 * Create Metabase Guest Token
 *
 * Sign a Metabase guest-embedding token for the given question.
 *
 * Only a question behind a report the caller can see is signed for, so a
 * token cannot be minted for an arbitrary Metabase question. Signing happens
 * here so the embedding secret key never reaches the browser.
 *
 * Company/facility/date filters stay editable and are driven by the reporting
 * frontend. The one locked parameter is ``allowed_regions``, set when any of
 * the question's reports is region-restricted, visible to the caller or not:
 * the restriction belongs to the question, so reports sharing one cannot
 * disagree on it.
 */
export const createMetabaseGuestToken = <ThrowOnError extends boolean = false>(options: Options<CreateMetabaseGuestTokenData, ThrowOnError>): RequestResult<CreateMetabaseGuestTokenResponses, CreateMetabaseGuestTokenErrors, ThrowOnError> => (options.client ?? client).post<CreateMetabaseGuestTokenResponses, CreateMetabaseGuestTokenErrors, ThrowOnError>({
    url: '/api/v1/metabase/guest-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Reports
 *
 * Reports visible to the caller's role, ordered by sort_order.
 *
 * Callers with the ``reporting.edit`` flag see every report regardless of
 * role restrictions, since they manage them.
 */
export const listReports = <ThrowOnError extends boolean = false>(options?: Options<ListReportsData, ThrowOnError>): RequestResult<ListReportsResponses, ListReportsErrors, ThrowOnError> => (options?.client ?? client).get<ListReportsResponses, ListReportsErrors, ThrowOnError>({ url: '/api/v1/reports', ...options });

/**
 * Create Report
 */
export const createReport = <ThrowOnError extends boolean = false>(options: Options<CreateReportData, ThrowOnError>): RequestResult<CreateReportResponses, CreateReportErrors, ThrowOnError> => (options.client ?? client).post<CreateReportResponses, CreateReportErrors, ThrowOnError>({
    url: '/api/v1/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Report
 */
export const deleteReport = <ThrowOnError extends boolean = false>(options: Options<DeleteReportData, ThrowOnError>): RequestResult<DeleteReportResponses, DeleteReportErrors, ThrowOnError> => (options.client ?? client).delete<DeleteReportResponses, DeleteReportErrors, ThrowOnError>({ url: '/api/v1/reports/{report_id}', ...options });

/**
 * Update Report
 */
export const updateReport = <ThrowOnError extends boolean = false>(options: Options<UpdateReportData, ThrowOnError>): RequestResult<UpdateReportResponses, UpdateReportErrors, ThrowOnError> => (options.client ?? client).patch<UpdateReportResponses, UpdateReportErrors, ThrowOnError>({
    url: '/api/v1/reports/{report_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Report
 *
 * One report by slug. A report the caller can't see is a 404, not a 403.
 */
export const getReport = <ThrowOnError extends boolean = false>(options: Options<GetReportData, ThrowOnError>): RequestResult<GetReportResponses, GetReportErrors, ThrowOnError> => (options.client ?? client).get<GetReportResponses, GetReportErrors, ThrowOnError>({ url: '/api/v1/reports/{slug}', ...options });

/**
 * Reorder Reports
 */
export const reorderReports = <ThrowOnError extends boolean = false>(options: Options<ReorderReportsData, ThrowOnError>): RequestResult<ReorderReportsResponses, ReorderReportsErrors, ThrowOnError> => (options.client ?? client).put<ReorderReportsResponses, ReorderReportsErrors, ThrowOnError>({
    url: '/api/v1/reports/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Subscription Auto Recipients
 *
 * List the users automatically added to a subscription's report emails.
 */
export const listSubscriptionAutoRecipients = <ThrowOnError extends boolean = false>(options: Options<ListSubscriptionAutoRecipientsData, ThrowOnError>): RequestResult<ListSubscriptionAutoRecipientsResponses, ListSubscriptionAutoRecipientsErrors, ThrowOnError> => (options.client ?? client).get<ListSubscriptionAutoRecipientsResponses, ListSubscriptionAutoRecipientsErrors, ThrowOnError>({ url: '/api/v1/subscriptions/auto-recipients', ...options });

/**
 * List Subscription Contacts
 *
 * List the contacts selectable as recipients for a subscription.
 */
export const listSubscriptionContacts = <ThrowOnError extends boolean = false>(options: Options<ListSubscriptionContactsData, ThrowOnError>): RequestResult<ListSubscriptionContactsResponses, ListSubscriptionContactsErrors, ThrowOnError> => (options.client ?? client).get<ListSubscriptionContactsResponses, ListSubscriptionContactsErrors, ThrowOnError>({ url: '/api/v1/subscriptions/contacts', ...options });

/**
 * List Subscriptions
 */
export const listSubscriptions = <ThrowOnError extends boolean = false>(options: Options<ListSubscriptionsData, ThrowOnError>): RequestResult<ListSubscriptionsResponses, ListSubscriptionsErrors, ThrowOnError> => (options.client ?? client).get<ListSubscriptionsResponses, ListSubscriptionsErrors, ThrowOnError>({ url: '/api/v1/subscriptions', ...options });

/**
 * Create Subscription
 */
export const createSubscription = <ThrowOnError extends boolean = false>(options: Options<CreateSubscriptionData, ThrowOnError>): RequestResult<CreateSubscriptionResponses, CreateSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<CreateSubscriptionResponses, CreateSubscriptionErrors, ThrowOnError>({
    url: '/api/v1/subscriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Subscription
 */
export const deleteSubscription = <ThrowOnError extends boolean = false>(options: Options<DeleteSubscriptionData, ThrowOnError>): RequestResult<DeleteSubscriptionResponses, DeleteSubscriptionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSubscriptionResponses, DeleteSubscriptionErrors, ThrowOnError>({ url: '/api/v1/subscriptions/{subscription_id}', ...options });

/**
 * Update Subscription
 */
export const updateSubscription = <ThrowOnError extends boolean = false>(options: Options<UpdateSubscriptionData, ThrowOnError>): RequestResult<UpdateSubscriptionResponses, UpdateSubscriptionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSubscriptionResponses, UpdateSubscriptionErrors, ThrowOnError>({
    url: '/api/v1/subscriptions/{subscription_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Subscription History
 */
export const getSubscriptionHistory = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionHistoryData, ThrowOnError>): RequestResult<GetSubscriptionHistoryResponses, GetSubscriptionHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetSubscriptionHistoryResponses, GetSubscriptionHistoryErrors, ThrowOnError>({ url: '/api/v1/subscriptions/{subscription_id}/history', ...options });

/**
 * Send Subscription
 *
 * Send a subscription's report immediately (on demand).
 *
 * Uses the same mechanism as the vellum-cron hourly job
 * (luna_lib.report_sending.send_subscription_report) so recipients get the
 * same email. Unlike the cron this ignores send_hour and the per-hour dedup
 * guard, so an operator can trigger a send at any time. The report is sent
 * ONLY to the addresses the operator confirmed in ``body.to_emails.
 *
 * Weekly recipients who are company contacts with report filters get their
 * narrowed copy, exactly as the cron would send it, so this returns one
 * history per email sent rather than a single history.
 *
 * Each of those emails is sent independently, so this returns the histories
 * for the ones that went out even when another failed; only a send where
 * every recipient failed is an error (502).
 */
export const sendSubscription = <ThrowOnError extends boolean = false>(options: Options<SendSubscriptionData, ThrowOnError>): RequestResult<SendSubscriptionResponses, SendSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<SendSubscriptionResponses, SendSubscriptionErrors, ThrowOnError>({
    url: '/api/v1/subscriptions/{subscription_id}/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
